/**
 * Brain API
 * =========
 * API functions for Zamanat Brain module: chat, drafts, KB versioning
 */

import apiClient from './client';

const BRAIN_BASE = '/api/v1/brain';
const KB_BASE = '/api/v1/knowledge-base';

// ─── Chat ────────────────────────────────────────────────────────────────────

export const sendChatMessage = async (sessionId, message) => {
  const response = await apiClient.post(`${BRAIN_BASE}/chat`, {
    session_id: sessionId,
    message,
  });
  return response.data;
};

export const getChatHistory = async (sessionId, limit = 50) => {
  const response = await apiClient.get(`${BRAIN_BASE}/chat/history`, {
    params: { session_id: sessionId, limit },
  });
  return response.data;
};

// ─── Drafts ──────────────────────────────────────────────────────────────────

export const getPendingDrafts = async (statusFilter = null, source = null, limit = 50, offset = 0) => {
  const params = { limit, offset };
  if (statusFilter) params.status_filter = statusFilter;
  if (source) params.source = source;
  const response = await apiClient.get(`${BRAIN_BASE}/drafts`, { params });
  return response.data;
};

export const getDraft = async (draftId) => {
  const response = await apiClient.get(`${BRAIN_BASE}/drafts/${draftId}`);
  return response.data;
};

export const approveDraft = async (draftId, comment = null) => {
  const response = await apiClient.post(`${BRAIN_BASE}/drafts/${draftId}/approve`, {
    comment,
  });
  return response.data;
};

export const rejectDraft = async (draftId, comment = null) => {
  const response = await apiClient.post(`${BRAIN_BASE}/drafts/${draftId}/reject`, {
    comment,
  });
  return response.data;
};

export const bulkRejectDrafts = async (draftIds, comment = null) => {
  const response = await apiClient.post(`${BRAIN_BASE}/drafts/bulk-reject`, {
    draft_ids: draftIds,
    comment,
  });
  return response.data;
};

// ─── KB Entry History ────────────────────────────────────────────────────────

export const getEntryHistory = async (entryId) => {
  const response = await apiClient.get(`${KB_BASE}/entries/${entryId}/history`);
  return response.data;
};

export const revertEntry = async (entryId, versionNumber) => {
  const response = await apiClient.post(`${KB_BASE}/entries/${entryId}/revert`, {
    version_number: versionNumber,
  });
  return response.data;
};

const brainAPI = {
  sendChatMessage,
  getChatHistory,
  getPendingDrafts,
  getDraft,
  approveDraft,
  rejectDraft,
  getEntryHistory,
  revertEntry,
};

export default brainAPI;
